module.exports = new __parcel__URL__("empty-add-card.19eb67a4.svg").toString();